// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alpaca-form > .alpaca-field-object {
  border: none;
  padding: 0;
}
/*# sourceMappingURL=AlpacaForm.css.map */`, "",{"version":3,"sources":["webpack://./AlpacaForm.less","webpack://./wp_components/AlpacaForm/AlpacaForm.less"],"names":[],"mappings":"AAAA;EAEQ,YAAA;EACA,UAAA;ACAR;AACA,yCAAyC","sourcesContent":[".alpaca-form {\n    > .alpaca-field-object {\n        border: none;\n        padding: 0;\n    }\n}",".alpaca-form > .alpaca-field-object {\n  border: none;\n  padding: 0;\n}\n/*# sourceMappingURL=AlpacaForm.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
